<template>
  <div id="sizeSelect" ref="selectRef" class="r-select">
    <ul class="r-select__options">
      <li
        v-for="spec in selectedData.Specs"
        :key="spec.Key"
        :class="{
          weak: spec.Stock < 1,
          selected: spec.ID === selectedSpecID,
        }"
        @click.prevent="selectSpec(spec)"
      >
        <a href="javascript:;"> {{ spec.Name }}<span v-if="spec.PreOrder"> (預)</span> </a>
      </li>
    </ul>
    <div v-if="isShowBranchStock" class="shop-store-btn" @click.prevent="showMobileStockDialog">
      <img src="https://static.tpx.tw/sff/pazzo-v2/static/img/url-logo.png" alt="" />
      門市庫存
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ProductSelect',
  data() {
    return {
      isShowBranchStock: window.ShowBranchStock,
    };
  },
  computed: {
    ...mapState('shopContent', ['selectedData', 'selectedSpecID', 'selectedSpec']),
  },
  methods: {
    ...mapActions('shopContent', ['selectSpec']),
    ...mapMutations('shopContent', ['showMobileStockDialog']),
  },
};
</script>
